export const badgesHeadersData = [
  {
    text: 'Icon',
    value: 'icon',
    sortable: true,
  },
  {
    text: 'Name',
    value: 'name',
    sortable: true,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: true,
  },
];
